import React from 'react';
import { createRoot } from 'react-dom/client';
import Drawings from '../components/Drawings';
const projectContainer = document.getElementById('drawings-page');

if (projectContainer) {
  const root = createRoot(projectContainer);
  root.render(
    // <React.StrictMode> // Optional, good for development
      <Drawings />
    // </React.StrictMode>
  );
} else {
  console.error("Root element for Drawings (#drawings-page) not found. Check your Rails view.");
}